import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../api/axiosConfig";
import { getLatestTaskList } from "../Firebase/getLatestTaskListAction";
import * as idb from '../../../functions/databaseService/indexedDB';
import signOut from "../../../functions/userIdentity/signOut";

// Action Types
export const CHANGE_PARENT_SUCCESS = "CHANGE_PARENT_SUCCESS";
export const CHANGE_PARENT_ERROR = "CHANGE_PARENT_ERROR";

// Thunk Action Creator
export const changeParentOfTask = createAsyncThunk(
    "api/Task/changeParent",
    async (json, { dispatch }) => {
        try {
            const online = navigator.onLine;

            if (online) {
                const response = await axios.put(
                    `${import.meta.env.VITE_PUBLIC_DOMAIN}Task/changeParent/${json.id}`,
                    {
                        id: json.id,
                        ParentId: json.ParentId,
                        SiblingPosition: json.SiblingPosition
                    },
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                )
                //Check for response - prevents error and also for offline 
                //Store API result into indexed DB
                if (response.status == 200) {
                    if (response.data === '') {
                        throw new Error("The last task has not been saved. Logging the user out");
                    } else {
                        idb.storeTaskList(response.data.tasks || response.data);
                    }
                }
                else {
                    throw new Error("Error occured changing parent");
                }
                //get data from indexed DB
                //const taskListData = await idb.getTasks();

                dispatch({
                    type: CHANGE_PARENT_SUCCESS,
                    payload: response.data,
                });
            } else {
                //get data from indexed DB
                const taskListData = await idb.getTasks();
                if (taskListData) {
                    //Dispatch Indexed DB instead of Axios result
                    dispatch({
                        type: CHANGE_PARENT_SUCCESS,
                        payload: taskListData
                    });
                }
                else {
                    console.log("No tasks found in IndexedDB");
                }
            }
        }
        catch (error) {
            dispatch({ type: CHANGE_PARENT_ERROR, payload: error });
            await signOut();
        }
        //.then(response => {
        //    dispatch({
        //        type: CHANGE_PARENT_SUCCESS,
        //        payload: response.data,
        //    });
        //    if (json.getTask === true) { dispatch(getLatestTaskList()); }
        //})
        //.catch(error => {
        //    dispatch({ type: CHANGE_PARENT_ERROR, payload: error });
        //});
    }
);
